module.exports = __webpack_public_path__ + "img/icon-closed-red.af86fd92.svg";